<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm @submit.prevent>
            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Включено
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Для главной страницы
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_main_page" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Для карусели подборок на главной
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_selection_carousel" />
                </CCol>
            </CRow>

            <CRow 
                form class="form-group"
                v-if="model.for_selection_carousel">
                <CCol
                    tag="label"
                    class="col-form-label ml-5">
                    Карусель подборок для бизнеса
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.entity_selection_carousel" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Для блока личного помощника на главной
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_assistant_block" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol tag="label" class="col-form-label" sm="3">
                    Показывать как рекламный баннер
                </CCol>
                <CCol sm="9">
                    <div class="d-flex mb-2">
                        <CSelect
                            v-model="selectedLocation"
                            :options="locationOptions"
                            placeholder="Выберите место показа"
                            class="mr-2"
                        />
                        <CButton 
                            color="primary" 
                            class="ml-3"
                            @click="addLocation" >
                            Добавить
                        </CButton>
                    </div>
                    <div v-if="errors.adsBannerLocations" class="text-danger">
                        {{ errors.adsBannerLocations }}
                    </div>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Место показа</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(location, index) in adsBannerLocations" :key="index">
                                <td>{{ getLocationLabel(location) }}</td>
                                <td>
                                    <CButton 
                                        color="danger" 
                                        size="sm" 
                                        @click="removeLocation(index)">
                                        <CIcon :content="cilTrash" />
                                    </CButton>
                                </td>
                            </tr>
                            <tr v-if="adsBannerLocations && adsBannerLocations.length === 0">
                                <td colspan="2" class="text-center">Нет выбранных мест показа.</td>
                            </tr>
                        </tbody>
                    </table>
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Показывать баннер "Что есть в МИРСИТИ"
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_mircity_banner" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Скрывать главный банер
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.hide_main_banner" />
                </CCol>
            </CRow>

            <CRow form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label"
                    sm="3">
                    Попап на главной
                </CCol>
                <CCol sm="9">
                    <CSwitch
                        class=""
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.for_popup_banner" />
                </CCol>
            </CRow>

            <CRow
                v-if="model.for_popup_banner"
                form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label ml-5">
                    Максимальное количество заказов у пользователя
                </CCol>
                <CCol sm="9">
                    <CInput
                        v-model="model.max_order_count"
                        horizontal/>
                </CCol>
            </CRow>

            <CRow
                v-if="model.for_popup_banner"
                form class="form-group">
                <CCol
                    tag="label"
                    class="col-form-label ml-5">
                    Название кнопки
                </CCol>
                <CCol sm="9">
                    <CInput
                        v-model="model.button_name"
                        horizontal/>
                </CCol>
            </CRow>

            <CRow
                form class="form-group"
                v-if="model.for_popup_banner">
                <CCol
                    tag="label"
                    class="col-form-label  ml-5">Новый клиент</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.new_client"
                        :options="new_clients"
                        placeholder="Новый клиент..."
                    />
                </CCol>
            </CRow>

            <CRow
                form class="form-group"
                v-if="model.for_popup_banner">
                <CCol
                    tag="label"
                    class="col-form-label ml-5">Авторизация</CCol>
                <CCol sm="9">
                    <CSelect
                        inline
                        :value.sync="model.authorized_client"
                        :options="authorized_clients"
                        placeholder="Авторизированный клиент..."
                    />
                </CCol>
            </CRow>

            <CRow
                form class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">
                    Версии показа
                </CCol>
                <CCol sm="4">
                    <CInput
                            v-model="model.start_version"
                            placeholder="С какой версии показывать"
                            class="w-100"
                        />
                </CCol>
                <CCol sm="1" class="col-form-label text-center">
                    по
                </CCol>
                <CCol sm="4">
                    <CInput
                            v-model="model.finish_version"
                            placeholder="С какой версии не показывать"
                            class="w-100"
                        />
                </CCol>
            </CRow>

            <div class="form-row">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Место показа</CCol>
                <CCol sm="9" class="col-form-label">
                    <CSelect
                        inline
                        :value.sync="model.route_name"
                        :options="routeNames"
                        placeholder="Место показа"
                        :is-valid="errors.route_name && errors.route_name.isValid"
                        @change="updateRouteName" />
                </CCol>
            </div>

            <CInput
                horizontal
                :value="model.code"
                label="Код AppsFlyer"
                placeholder="Код для регистрации событий в AppsFlyer"
                @change="updateCode" />

            <CInput
                v-model="model.title"
                horizontal
                label="Название акции"
                placeholder="Введите название акции"
                :is-valid="errors.title && errors.title.isValid" />

            <CTextarea
                v-model="model.description"
                horizontal
                label="Описание акции"
                placeholder="Введите описание акции" />

            <CInput
                v-model="model.place"
                horizontal
                label="Позиция показа *"
                placeholder="Введите позицию показа" />
            <CInput
                v-model="model.max_shown_count"
                type="number"
                horizontal
                label="Лимит показов банера"
                placeholder="Максимальное количество показов банера" />
            <CInput
                v-model="model.shown_delay"
                class="mb-0"
                type="number"
                horizontal
                label="Пауза между показами"
                placeholder="Пауза между показами баннера (сек)" />
            <CRow class="mb-3">
                <CCol sm="3"></CCol>
                <CCol sm="9">
                    Задается в секундах. Примеры:<br>
                    1 минута = 60 сек<br>
                    1 час = 3600 сек<br>
                    1 сутки = 86400 сек<br>
                </CCol>
            </CRow>

            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                <CInput
                    v-model="model.main_text"
                    horizontal
                    label="Основной текст"
                    placeholder="Введите основной текст"
                    :is-valid="errors.main_text && errors.main_text.isValid" />

                <CInput
                    v-model="model.additional_text"
                    horizontal
                    label="Дополнительный текст"
                    placeholder="Введите дополнительный текст"
                    :is-valid="
                        errors.additional_text && errors.additional_text.isValid
                    " />
            </div>

            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                <CRow>
                    <CCol sm="3" class="col-form-label">Тип отображаемого контента</CCol>
                    <CCol sm="9">
                        <CSelect
                            inline
                            :value.sync="model.content_type"
                            :options="contentTypes"
                            placeholder=""
                        />
                    </CCol>
                </CRow>

                <template v-if="['image', 'image_bg'].includes(model.content_type)">
                    <div v-if="model.picture" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.picture)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>

                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка основная"
                        :is-valid="errors.picture && errors.picture.isValid"
                        @change="selectPicture" />


                    <div v-if="model.desktop_picture" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.desktop_picture)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>
                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка для десктопа"
                        :is-valid="errors.desktop_picture && errors.desktop_picture.isValid"
                        @change="selectDesktopPicture" />


                    <div v-if="model.selection_picture" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.selection_picture)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>
                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка для подборки (на главной)"
                        :is-valid="errors.selection_picture && errors.selection_picture.isValid"
                        @change="selectSelectionPicture" />

                    <div v-if="model.picture_for_product" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.picture_for_product)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>
                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка (икнока) для списка товаров"
                        :is-valid="errors.picture_for_product && errors.picture_for_product.isValid"
                        @change="selectProductPicture" />

                    <div v-if="model.picture_main_page" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.picture_main_page)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>
                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка для главной (большая)"
                        :is-valid="errors.picture_main_page && errors.picture_main_page.isValid"
                        @change="selectPictureMainPage" />

                    <div v-if="model.picture_main_page_sq" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.picture_main_page_sq)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </div>
                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Картинка для главной (маленькая)"
                        :is-valid="errors.picture_main_page_sq && errors.picture_main_page_sq.isValid"
                        @change="selectPictureMainPageSq" />
                </template>

                <template v-if="['video_mp4', 'video_webm'].includes(model.content_type)">
                    <div v-if="model.picture" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl(model.picture)"
                                class="m2"
                                width="400" />
                        </CCol>
                    </div>

                    <CInputFile
                        ref="picture"
                        horizontal
                        label="Постер (показывается пока видео не загружено)"
                        :is-valid="errors.picture && errors.picture.isValid"
                        @change="selectPicture" />

                    <div v-if="model.video" class="form-row">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <video playsinline autoplay muted loop width="400">
                                <source :src="pictureUrl(model.video)" type="video/mp4">
                                Ваш браузер не поддерживает встроенные видео :(
                            </video>
                        </CCol>
                    </div>

                    <CInputFile
                        ref="video"
                        horizontal
                        label="Видео"
                        :is-valid="errors.video && errors.video.isValid"
                        @change="selectVideo" />
                </template>
            </div>

            <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                <CRow>
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Расширенное время показа (Пример: с 07:00, до 02:00 след. дня)
                    </CCol>
                    <CCol sm="9">
                        <CSwitch
                            color="success"
                            shape="pill"
                            variant="opposite"
                            :checked.sync="model.extended_schedule"
                        />
                    </CCol>
                </CRow>

                <ScheduleUpdate :schedule="schedule" @set-schedule="setSchedule" />
            </div>

            <div class="border border-gray-300 rounded-md p-2 mb-4">
                <div class="form-row">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">Открывается при клике:</CCol>
                    <CCol sm="9" class="col-form-label">
                        <CSelect
                            inline
                            :value.sync="model.type"
                            :options="types"
                            @change="updateType" />
                    </CCol>
                </div>

                <CInput
                    v-if="model.type === 'link' || model.type === 'external_link'"
                    v-model="model.link"
                    horizontal
                    label="Ссылка"
                    placeholder="Введите ссылку на страницу, которая будет открываться при клике по банеру"
                    :is-valid="errors.link && errors.link.isValid" />

                <template v-if="model.type === 'list'">
                    <CRow>
                        <CCol tag="label" class="col-form-label">{{ routeNamesMap[model.route_name] }}</CCol>
                    </CRow>
                    <Draggable v-model="entitiesList" tag="div">
                        <CRow v-for="item in entitiesList" :key="item.id">
                            <CCol
                                tag="label"
                                sm="1"
                                class="col-form-label">
                                <CIcon
                                    :height="16"
                                    :content="cilCursorMove"
                                    class="handle" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="4"
                                class="col-form-label">
                                {{ item.title }}
                            </CCol>
                            <CCol
                                tag="label"
                                sm="6"
                                class="col-form-label">
                                <CButton
                                    v-if="list[item.id]"
                                    variant="outline"
                                    :color="
                                        bannerPictures.length && bannerPictures.find(picture => picture.entity_id === item.id)
                                            ? 'warning'
                                            : 'success'
                                    "
                                    @click="openModal(item.id)"
                                >Изображение
                                </CButton>
                            </CCol>
                            <CCol sm="1">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="list[item.id]" />
                            </CCol>
                        </CRow>
                    </Draggable>
                </template>

                <div
                    v-if="model.type === 'products_list'"
                    class="form-row">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">Партнер:</CCol>
                    <CCol sm="9" class="col-form-label">
                        <CSelect
                            inline
                            :value.sync="model.entity_id_for_product"
                            :options="entityOptions"
                            @change="updateEntity" />
                    </CCol>
                </div>

                <div
                    v-if="model.type === 'product_detail'"
                    class="form-row">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">Партнер:</CCol>
                    <CCol sm="9" class="col-form-label">
                        <CSelect
                            inline
                            :value.sync="selectedProductDetailEntity"
                            :options="productDetailEntityOptions"
                            @change="updateProductDetailEntity" />
                    </CCol>
                </div>

                <div
                    v-if="model.type === 'stories'"
                    class="form-row">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">Сторис:</CCol>
                    <CCol sm="9" class="col-form-label">
                        <CSelect
                            inline
                            :value.sync="model.stories_id"
                            :options="storiesOptions"
                            @change="updateStories" />
                    </CCol>
                </div>

                <CRow v-if="model.type === 'product_detail'">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">Продукт:</CCol>
                    <CCol sm="9">
                        <template v-if="selectItem">
                            <span class="banner-item-edit__product_title">{{ selectItem.title }}</span>
                            <CButton
                                color="light"
                                class="ml-3"
                                @click="clearProduct"
                            >Очистить</CButton>
                        </template>
                        <template v-else>
                            <Autocomplete
                                ref="autocompleteProduct"
                                placeholder="Введите ID или часть названия"
                                :search="getProducts"
                                :get-result-value="getResultValue"
                                @submit="updateProductDetail"
                            />
                        </template>
                    </CCol>
                </CRow>

                <CRow v-if="model.type === 'products_list'">
                    <CCol class="form-group text-right">
                        <CButton
                            color="primary"
                            class="ml-3"
                            @click="itemAdd">Добавить позицию</CButton>
                    </CCol>
                </CRow>

                <CRow v-if="model.type === 'products_list'" class="pl-3">
                    <table class="table">
                        <thead>
                            <th></th>
                            <th>Наименование товара</th>
                            <th>Сервис</th>
                            <th></th>
                        </thead>
                        <Draggable v-model="productsList" tag="tbody">
                            <tr v-for="product in productsList" :key="product.id">
                                <td><CIcon
                                        :height="24"
                                        :content="cilCursorMove"
                                        class="handle" /></td>
                                <td><strong>{{ product.title }}</strong></td>
                                <td v-if="model.route_name === 'restaurant-list'">{{ getTitleService(product.restaurant_id) }}</td>
                                <td v-else-if="model.route_name === 'grocery-list'">{{ getTitleService(product.grocer_id) }}</td>
                                <td v-else-if="model.route_name === 'pharmacy-list'">{{ getTitleService(product.pharmacy_id) }}</td>
                                <td v-else-if="model.route_name === 'assistant-list'">{{ getTitleService(product.assistant_id) }}</td>
                                <td v-else></td>
                                <td><CButton @click="removeProduct(product.id)"><CIcon :content="cilTrash" class="handle" /></CButton></td>
                            </tr>
                        </Draggable>
                    </table>
                </CRow>
            </div>

            <div class="flex mt-4">
                <CButton color="primary" @click="submit">{{ submitButtonTitle }}
                </CButton>
                <CButton
                    v-if="model.id"
                    variant="outline"
                    color="danger"
                    class="ml-4"
                    @click="promptDelete">Удалить
                </CButton>
            </div>
        </CForm>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />

        <CModal
            title="Подтверждение"
            color="primary"
            :show.sync="pictureModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Картинка сервиса внутри баннера:
                    </p>
                    <CRow v-if="servicePictureUrl(selectedService, selectedServiceType)">
                        <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="servicePictureUrl(selectedService, selectedServiceType)"
                                class="m2"
                                width="200" />
                        </CCol>
                    </CRow>
                    <CInputFile
                        ref="picture"
                        label="Изображение"
                        horizontal
                        @change="selectServicePicture" />
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="pictureModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deletePicture">Удалить</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="savePicture">Сохранить</CButton>
                </div>
            </template>
        </CModal>
        <CModal
            v-if="model.type === 'products_list'"
            title="Редактирование товара"
            :show.sync="visible"
            class="banner-item-edit">
            <CRow
                form
                class="form-group">
                <CCol
                    tag="label"
                    sm="3"
                    class="col-form-label">Товар</CCol>
                <CCol sm="9">
                    <template v-if="selectItem">
                        <span class="banner-item-edit__product_title">{{ selectItem.title }}</span>
                    </template>
                    <template v-else>
                        <Autocomplete
                            ref="autocomplete"
                            placeholder="Введите ID или часть названия"
                            :search="getProducts"
                            :get-result-value="getResultValue"
                            @submit="updateProduct"
                        />
                    </template>
                    <br>
                </CCol>
            </CRow>
            <div slot="footer">
                <CButton
                    color="light"
                    class="ml-3"
                    @click="clearProduct"
                >Очистить</CButton>
                <CButton
                    color="primary"
                    class="ml-3"
                    @click="updateProducts"
                >Добавить</CButton>
                <CButton
                    color="danger"
                    class="ml-3"
                    @click="cancelModal"
                >Выйти</CButton>
            </div>
        </CModal>
    </AppFormValidator>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule } from '@/utils/rules';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { AUTHORIZATION_CHECK, CHECK_NEW_CLIENT } from '@/utils/popup-main-page';
    import { translit } from '@/utils/translit';
    import { cilCursorMove, cilTrash } from '@coreui/icons';
    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import Draggable from 'vuedraggable';
    import ScheduleUpdate from '@/components/ScheduleUpdate';
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import '@trevoreyre/autocomplete-vue/dist/style.css';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
            Draggable,
            ScheduleUpdate,
            Autocomplete,
        },
        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                schedule: null,
                cilCursorMove,
                cilTrash,
                model: {},
                authorized_clients: null,
                new_clients: null,
                stories: [],
                adsBannerLocations: [],
                locationOptions: [
                    { value: 'profile', label: 'В профиле' },
                    { value: 'restaurant', label: 'В ресторанах' },
                    { value: 'grocery', label: 'В магазинах' },
                ],
                selectedLocation: null,
                schema: {
                    id: 'id',
                    code: 'code',
                    type: 'type',
                    content_type: 'content_type',
                    title: 'title',
                    place: 'place',
                    description: 'description',
                    route_name: 'route_name',
                    video: 'video',
                    picture: 'picture',
                    desktop_picture: 'desktop_picture',
                    selection_picture: 'selection_picture',
                    picture_for_product: 'picture_for_product',
                    picture_main_page: 'picture_main_page',
                    picture_main_page_sq: 'picture_main_page_sq',
                    main_text: 'main_text',
                    additional_text: 'additional_text',
                    link: 'link',
                    list: 'list',
                    products_list: 'products_list',
                    stories_id: 'stories_id',
                    schedule: 'schedule',
                    max_order_count: 'max_order_count',
                    max_shown_count: 'max_shown_count',
                    shown_delay: 'shown_delay',
                    button_name: 'button_name',
                    start_version: 'start_version',
                    finish_version: 'finish_version',
                    entity_id_for_product: 'entity_id_for_product',
                    entity_code_for_product: 'entity_code_for_product',
                    product_id: 'product_id',
                    service_type: 'service_type',
                    new_client: 'new_client',
                    authorized_client: 'authorized_client',
                    ads_banner_locations: 'ads_banner_locations',
                    enabled: source => Boolean(source.enabled),
                    for_main_page: source => Boolean(source.for_main_page),
                    hide_main_banner: source => Boolean(source.hide_main_banner),
                    for_selection_carousel: source => Boolean(source.for_selection_carousel),
                    for_assistant_block: source => Boolean(source.for_assistant_block),
                    entity_selection_carousel: source => Boolean(source.entity_selection_carousel),
                    for_popup_banner: source => Boolean(source.for_popup_banner),
                    for_mircity_banner: source => Boolean(source.for_mircity_banner),
                    extended_schedule: source => Boolean(source.extended_schedule),
                },
                rules: {
                    route_name: [requiredRule],
                    title: [requiredRule],
                    enabled: [requiredRule],
                },
                contentTypes: [
                    {
                        label: 'Изображение центрированое (по умолчанию)',
                        value: 'image',
                    },
                    {
                        label: 'Изображение как фон',
                        value: 'image_bg',
                    },
                    {
                        label: 'Видео в формате mp4',
                        value: 'video_mp4',
                    },
                    {
                        label: 'Видео в формате webm',
                        value: 'video_webm',
                    },
                ],
                routeNames: [
                    {
                        label: 'Список ресторанов',
                        value: 'restaurant-list',
                        listVar: 'restaurants',
                    },
                    {
                        label: 'Список продуктовых магазинов',
                        value: 'grocery-list',
                        listVar: 'grocers',
                    },
                    {
                        label: 'Список аптек',
                        value: 'pharmacy-list',
                        listVar: 'pharmacies',
                    },
                    {
                        label: 'Список помощников',
                        value: 'assistant-list',
                        listVar: 'assistants',
                    },
                ],
                routeNamesMap: {
                    'restaurant-list': 'Список ресторанов',
                    'grocery-list': 'Список продуктовых магазинов',
                    'pharmacy-list': 'Список аптек',
                    'assistant-list': 'Список помощников',
                },
                types: [
                    {
                        label: 'Ничего',
                        value: 'none',
                    },
                    {
                        label: 'Ссылка на страницу',
                        value: 'link',
                    },
                    {
                        label: 'Внешняя ссылка',
                        value: 'external_link',
                    },
                    {
                        label: 'Список бизнесов',
                        value: 'list',
                    },
                    {
                        label: 'Список блюд',
                        value: 'products_list',
                    },
                    {
                        label: 'Продукт',
                        value: 'product_detail',
                    },
                    {
                        label: 'Сторис',
                        value: 'stories',
                    }
                ],
                list: [],
                business: {
                    restaurants: [],
                    grocers: [],
                    pharmacies: [],
                    assistants: [],
                },
                selectedPicture: null,
                selectedVideo: null,
                selectedPictureMainPage: null,
                selectedPictureMainPageSq: null,
                entitiesCopy: [],
                entitiesOrder: [],
                routeName: '',
                entities: {},

                visible: false,
                selectItem: null,
                productType: null,
                productsList: [],
                serviceType: '',
                productDetailServiceType: '',
                productDetailProductType: '',
                productDetailEntityTypeCode: '',

                bannerPictures: [],
                selectedService: null,
                selectedServiceType: '',
                selectedServicePicture: null,
                pictureModal: false,
                max_shown_count: null,
                shown_delay: null,
            };
        },

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            entitiesList: {
                get() {
                    return this.entitiesCopy;
                },

                set(v) {
                    this.entitiesCopy = v;
                }
            },
            storiesOptions: function () {
                return this.stories.map(story => {
                    return {
                        label: story.title,
                        value: story.id,
                    };
                });
            },
            entityOptions: function() {
                const entityOptions = [];
                entityOptions.push({
                    value: null,
                    label: 'Сервис..'
                })
                this.entitiesList.forEach(entity => {
                    entityOptions.push({
                        value: entity.id,
                        label: entity.title
                    });
                });
                entityOptions.sort((a, b) => a.label > b.label ? 1 : -1);
                return entityOptions;
            },
            selectedProductDetailEntity: {
                get() {
                    if (!this.model.entity_id_for_product || !this.model.service_type) {
                        return '';
                    }
                    // Формируем значение в формате {type}_{id}
                    return `${this.model.service_type}_${this.model.entity_id_for_product}`;
                },
                set(value) {
                    // Setter не используется, так как обновление идет через updateProductDetailEntity
                }
            },
            productDetailEntityOptions: function() {
                const entityOptions = [];
                entityOptions.push({
                    value: '',
                    label: 'Выберите партнера...',
                    serviceType: null,
                    entityId: null,
                    entityCode: null
                });

                // Добавляем рестораны
                this.business.restaurants.forEach(entity => {
                    entityOptions.push({
                        value: `restaurant_${entity.id}`,
                        label: `[Ресторан] ${entity.title}`,
                        serviceType: 'restaurants',
                        entityId: entity.id,
                        entityCode: entity.code
                    });
                });

                // Добавляем продуктовые магазины
                this.business.grocers.forEach(entity => {
                    entityOptions.push({
                        value: `grocer_${entity.id}`,
                        label: `[Магазин] ${entity.title}`,
                        serviceType: 'grocers',
                        entityId: entity.id,
                        entityCode: entity.code
                    });
                });

                // Добавляем аптеки
                this.business.pharmacies.forEach(entity => {
                    entityOptions.push({
                        value: `pharmacy_${entity.id}`,
                        label: `[Аптека] ${entity.title}`,
                        serviceType: 'pharmacies',
                        entityId: entity.id,
                        entityCode: entity.code
                    });
                });

                // Добавляем entities из динамических типов
                const entityTypes = Object.keys(this.business).filter(key => 
                    !['restaurants', 'grocers', 'pharmacies', 'assistants'].includes(key)
                );
                
                entityTypes.forEach(typeKey => {
                    if (this.business[typeKey] && Array.isArray(this.business[typeKey])) {
                        this.business[typeKey].forEach(entity => {
                            entityOptions.push({
                                value: `entity_${entity.id}`,
                                label: `[${typeKey}] ${entity.title}`,
                                serviceType: 'entities',
                                entityId: entity.id,
                                entityTypeCode: typeKey,
                                entityCode: entity.code
                            });
                        });
                    }
                });

                entityOptions.sort((a, b) => {
                    if (!a.label || !b.label) return 0;
                    return a.label > b.label ? 1 : -1;
                });
                return entityOptions;
            },
        },

        mounted(){
            if(!this.authorized_clients) {
                const types = [];
                types.push({ value: AUTHORIZATION_CHECK.AUTHORIZED, label: 'Авторизованные' });
                types.push({ value: AUTHORIZATION_CHECK.NOT_AUTHORIZED, label: 'Не аворизованные' });
                types.push({ value: AUTHORIZATION_CHECK.NO_MATER, label: 'Неважно' });
                this.authorized_clients = types;
            };

            if(!this.new_clients) {
                const types = [];
                types.push({ value: CHECK_NEW_CLIENT.FOR_NEW, label: 'Да' });
                types.push({ value: CHECK_NEW_CLIENT.NOT_NEW, label: 'Нет' });
                types.push({ value: CHECK_NEW_CLIENT.NO_MATER, label: 'Неважно' });
                this.new_clients = types;
            }
        },

        watch: {
            async routeName() {
                for (let i = 0; i < this.routeNames.length; i++) {
                    if (this.routeNames[i].value === this.routeName) {
                        this.entities = this.business[this.routeNames[i].listVar] || [];
                        this.entitiesCopy = this.entities;
                    }
                }
            }
        },

        async created() {
            await this.fetch();
        },

        methods: {
            getLocationLabel(value) {
                const option = this.locationOptions.find(opt => opt.value === value);
                return option ? option.label : value;
            },
            addLocation() {
                if (!this.selectedLocation) {
                    this.$root.$emit('showError', 'Пожалуйста, выберите место показа перед добавлением.');
                    return;
                }

                if (this.adsBannerLocations.includes(this.selectedLocation)) {
                    this.$root.$emit('showError', 'Это место показа уже добавлено.');
                    return;
                }

                this.adsBannerLocations.push(this.selectedLocation);
                this.selectedLocation = null;
            },
            removeLocation(index) {
                this.adsBannerLocations.splice(index, 1);
            },
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            async fetch() {
                const id = this.$route.params.id;
                if(id) {
                    const { data: banner } = await Vue.axios.get('/banners/' + id);
                    this.model = morphism(this.schema, banner);
                }

                if (this.model.schedule && this.model.schedule.length != 0) {
                    for(let i=0; i<this.model.schedule.length; i++) {
                        this.model.schedule[i].enabled = !!this.model.schedule[i].enabled;
                        this.model.schedule[i].around_the_clock = !!this.model.schedule[i].around_the_clock;
                    }
                    this.setSchedule(this.model.schedule);
                }

                this.entitiesOrder = this.entity.list || [];

                if (this.entity.products_list) {
                    this.getBusinesType();
                    this.getProductsByIds(this.serviceType, this.entity.products_list);
                }

                const { data: restaurants } = await Vue.axios.get('/restaurants');
                this.business.restaurants = this.entity.id ? this.orderServices(restaurants) : restaurants;
                const { data: grocers } = await Vue.axios.get('/grocers');
                this.business.grocers = grocers;
                const { data: pharmacies } = await Vue.axios.get('/pharmacies');
                this.business.pharmacies = pharmacies;
                const { data: assistants } = await Vue.axios.get('/assistants');
                this.business.assistants = assistants;

                const { data: entityTypes } = await Vue.axios.get('/entities-type');
                await Promise.all(entityTypes.map(async type => {
                    const entities = await Vue.axios.get(`/entities/${type.code}`);
                    this.$set(this.business, type.code, entities?.data?.length ? entities.data : []);
                    this.routeNames.push({
                        label: type.title,
                        value: `entity-list-${type.code}`,
                        listVar: type.code,
                    })
                }));

                const { data: stories } = await Vue.axios.get('/stories');
                this.stories = stories;
                this.stories.push({title: 'Ничего', id: null});

                this.routeName = this.entity.id ? this.entity.route_name : 'restaurant-list';
                this.new_client = this.entity.new_client ? this.entity.new_client : null;
                this.authorized_client = this.entity.authorized_client ? this.entity.authorized_client : null;
                this.bannerPictures = this.entity.bannerPictures;
                this.adsBannerLocations = this.entity?.ads_banner_locations || [];
                await this.setModel();
            },
            orderServices(services) {
                if (services?.length) {
                    const servicesCopy = [...services];
                    if(this.entitiesOrder) {
                        this.entitiesOrder.forEach((order, ind) => {
                            const index = servicesCopy.findIndex(el => el.id === order);
                            if (index !== -1) {
                                const [service] = servicesCopy.splice(index, 1);
                                servicesCopy.splice(ind, 0, service);
                            }
                        });
                    }
                    return servicesCopy;
                }
                return [];
            },
            serviceTypeToSingular(pluralType) {
                const map = {
                    'restaurants': 'restaurant',
                    'grocers': 'grocer',
                    'pharmacies': 'pharmacy',
                    'entities': 'entity'
                };
                return map[pluralType] || pluralType;
            },
            serviceTypeToPlural(singularType) {
                const map = {
                    'restaurant': 'restaurants',
                    'grocer': 'grocers',
                    'pharmacy': 'pharmacies',
                    'entity': 'entities'
                };
                return map[singularType] || singularType;
            },
            updateRouteName(e) {
                this.model.route_name = e.target.value;
                this.routeName = this.model.route_name;
                this.list = [];
                this.productsList = [];
            },
            updateType(e) {
                this.model.type = e.target.value;
                // Очищаем выбранный продукт при смене типа
                if (this.model.type !== 'product_detail') {
                    this.selectItem = null;
                    this.model.product_id = null;
                    this.model.service_type = null;
                    this.model.entity_code_for_product = null;
                    this.productDetailServiceType = '';
                    this.productDetailProductType = '';
                }
            },
            updateCode(code) {
                this.model.code = translit(code).toUpperCase().replace(/[-]/g, '_').substring(0, 20);
            },
            pictureUrl(picture) {
                return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
            },

            async setModel() {
                this.model = morphism(this.schema, this.entity);
                this.model.route_name =
                    this.model.route_name || this.routeNames[0].value;
                this.model.type = this.model.type || this.types[0].value;
                this.model.list = this.model.list || [];
                this.model.products_list = this.model.products_list || [];
                this.model.product_id = this.model.product_id || null;
                this.model.service_type = this.model.service_type || null;
                this.model.entity_code_for_product = this.model.entity_code_for_product || null;
                this.model.new_client = this.model.new_client || null;
                this.model.authorized_client = this.model.authorized_client || null;
                this.model.content_type = this.model.content_type || 'image';
                this.model.ads_banner_locations = this.adsBannerLocations || [];

                // Загружаем выбранный продукт для product_detail
                if (this.model.type === 'product_detail' && this.model.product_id) {
                    await this.loadProductDetail();
                }
                
                setTimeout(() => {
                    this.list = [];
                    for (var i = 0; i < this.entities.length; i++) {
                        this.list[this.entities[i].id] = this.model.list.includes(
                            this.entities[i].id
                        );
                    }
                }, 100);
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            selectVideo(FileList) {
                this.selectedVideo = FileList[0];
            },

            selectDesktopPicture(FileList) {
                this.selectedDesktopPicture = FileList[0];
            },

            selectSelectionPicture(FileList) {
                this.selectedSelectionPicture = FileList[0];
            },

            selectProductPicture(FileList) {
                this.selectedProductPicture = FileList[0];
            },

            selectPictureMainPage(FileList) {
                this.selectedPictureMainPage = FileList[0];
            },

            selectPictureMainPageSq(FileList) {
                this.selectedPictureMainPageSq = FileList[0];
            },

            async submit() {
                if (!this.selectedPicture && !this.entity.id) {
                    this.$root.$emit('showError', 'Выберите картинку баннера.');
                    return;
                }
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                this.model.enabled = this.model.enabled ? true : false;
                this.model.extended_schedule = !!this.model.extended_schedule;
                this.model.schedule = this.schedule;
                this.model.new_client = this.model.new_client;
                this.model.authorized_client = this.model.authorized_client;
                this.model.ads_banner_locations = this.adsBannerLocations;

                // Загружаем картинку
                if (this.selectedPicture) {
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.picture = resp.data.filename;
                }

                if(this.selectedVideo) {
                    let formData = new FormData();
                    formData.append('file', this.selectedVideo);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.video = resp.data.filename;
                }

                // Загружаем картинку для декстопа
                if (this.selectedDesktopPicture) {
                    let formData = new FormData();
                    formData.append('file', this.selectedDesktopPicture);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.desktop_picture = resp.data.filename;
                }

                // Загружаем картинку для подборки
                if (this.selectedSelectionPicture) {
                    let formData = new FormData();
                    formData.append('file', this.selectedSelectionPicture);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.selection_picture = resp.data.filename;
                }
                
                // Загружаем картинку (иконку) для подборки товаров
                if (this.selectedProductPicture) {
                    let formData = new FormData();
                    formData.append('file', this.selectedProductPicture);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.picture_for_product = resp.data.filename;
                }

                // Загружаем картинку для главной (большая)
                if (this.selectedPictureMainPage) {
                    let formData = new FormData();
                    formData.append('file', this.selectedPictureMainPage);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.picture_main_page = resp.data.filename;
                }

                // Загружаем картинку для главной (маленькая)
                if (this.selectedPictureMainPageSq) {
                    let formData = new FormData();
                    formData.append('file', this.selectedPictureMainPageSq);
                    const resp = await this.axios.post('/files/upload', formData);
                    this.model.picture_main_page_sq = resp.data.filename;
                }

                this.model.list = [];
                for (var i = 0; i < this.entitiesCopy.length; i++) {
                    if (this.list[this.entitiesCopy[i].id]) {
                        this.model.list.push(this.entitiesCopy[i].id);
                    }
                }
                this.model.products_list = [];
                for (let i = 0; i < this.productsList.length; i++) {
                    if (this.productsList[i].id) {
                        this.model.products_list.push(this.productsList[i].id);
                    }
                }

                if (typeof this.model.id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/banners/${this.model.id}`, this.model)
                    );
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись. ' + err);
                        return;
                    }
                } else {
                    const [err] = await to(this.axios.post('/banners', this.model));
                    if (err) {
                        this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись. ' + err);
                        return;
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/banners/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления записи. ' + error);
                    return;
                }

                this.$emit('deleted');
            },

            selectServicePicture(FileList) {
                this.selectedServicePicture = FileList[0];
            },

            servicePictureUrl(id, type) {
                const url = this.bannerPictures?.find(picture => picture.entity_id === id && picture.entity_type === type)?.picture || null;
                if (url) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        url
                    );
                } else {
                    return '';
                }
            },

            openModal(id) {
                this.selectedService = id;
                this.pictureModal = !this.pictureModal;
                switch (this.model.route_name) {
                case 'restaurant-list':
                    this.selectedServiceType = BUSINESS_TYPE.RESTAURANT;
                    break;
                case 'grocery-list':
                    this.selectedServiceType = BUSINESS_TYPE.GROCER;
                    break;
                case 'pharmacy-list':
                    this.selectedServiceType = BUSINESS_TYPE.PHARMACY;
                    break;
                case 'assistant-list':
                    this.selectedServiceType = BUSINESS_TYPE.ASSISTANT;
                    break;
                default:
                    this.selectedServiceType = BUSINESS_TYPE.ENTITY;
                    break;
                }
            },

            async savePicture() {
                let formData = new FormData();
                if (this.selectedServicePicture) {
                    formData.append('file', this.selectedServicePicture);
                    const servicePictureName = await Vue.axios.post('/files/upload', formData);
                    await Vue.axios.post('/banners/pictures', {
                        banner_id: this.model.id,
                        entity_type: this.selectedServiceType,
                        entity_id: this.selectedService,
                        picture: servicePictureName.data.filename
                    });
                    this.$emit('update');
                    await this.fetch();
                    this.pictureModal = !this.pictureModal;
                }
            },

            async deletePicture() {
                const id = this.bannerPictures
                    .find(picture => picture.entity_id === this.selectedService
                    && picture.entity_type === this.selectedServiceType)?.id || null;
                if (id) {
                    await Vue.axios.delete(`/banners/pictures/${id}`);
                    this.$emit('update');
                    await this.fetch();
                    this.pictureModal = !this.pictureModal;
                }
            },

            async getProducts(search) {
                // Для product_detail используем productDetailServiceType, иначе getBusinesType
                let serviceType, productType;
                
                if (this.model.type === 'product_detail') {
                    serviceType = this.productDetailServiceType;
                    productType = this.productDetailProductType;
                } else {
                    this.getBusinesType();
                    serviceType = this.serviceType;
                    productType = this.productType;
                }
                
                return new Promise(resolve => {
                    if (search.length < 2) {
                        return resolve([]);
                    }
                    
                    if (!serviceType || !productType || !this.model.entity_id_for_product) {
                        return resolve([]);
                    }
                    
                Vue.axios
                    .get(`/${ serviceType }/${ this.model.entity_id_for_product }/${ productType }?search=${ search }`, {})
                    .then(resp => {
                        resolve(resp.data.results);
                    })
                    .catch(err => {
                        console.log('Cannot load products list.');
                    });
                })
            },
            getResultValue(result) {
                return result.title;
            },
            async updateProducts() {
                this.productsList.push(this.selectItem);
                this.selectItem = null;
            },
            itemAdd() {
                this.visible = true;
            },
            updateEntity(e) {
                this.model.entity_id_for_product = e.target.value;
                this.getBusinesType();
            },
            updateProductDetailEntity(e) {
                const selectedValue = e.target.value;
                
                // Находим выбранную опцию для получения serviceType и entityId
                const selectedOption = this.productDetailEntityOptions.find(
                    opt => opt.value === selectedValue
                );
                
                if (selectedOption && selectedOption.entityId) {
                    // Устанавливаем entity_id_for_product (только числовой ID)
                    this.model.entity_id_for_product = selectedOption.entityId;
                    
                    // Записываем entity.code в entity_code_for_product
                    this.model.entity_code_for_product = selectedOption.entityCode;
                    
                    this.productDetailServiceType = selectedOption.serviceType;
                    this.productDetailEntityTypeCode = selectedOption.entityTypeCode || '';
                    
                    // Устанавливаем productType в зависимости от serviceType
                    if (this.productDetailServiceType === 'restaurants') {
                        this.productDetailProductType = 'dishes';
                    } else if (this.productDetailServiceType === 'grocers') {
                        this.productDetailProductType = 'goods';
                    } else if (this.productDetailServiceType === 'pharmacies') {
                        this.productDetailProductType = 'drugs';
                    } else if (this.productDetailServiceType === 'entities') {
                        this.productDetailProductType = 'entity_products';
                    }
                    
                    // Сохраняем service_type в модель (в единственном числе)
                    this.model.service_type = this.serviceTypeToSingular(this.productDetailServiceType);
                } else {
                    // Если не выбрано - очищаем
                    this.model.entity_id_for_product = null;
                    this.model.entity_code_for_product = null;
                    this.model.service_type = null;
                    this.productDetailServiceType = '';
                    this.productDetailProductType = '';
                }
                
                // Очищаем выбранный продукт при смене партнера
                this.selectItem = null;
                this.model.product_id = null;
            },
            updateStories(e) {
                this.model.stories_id = e.target.value;
            },
            getBusinesType () {
                switch (this.model.route_name) {
                case 'restaurant-list':
                    this.serviceType = 'restaurants';
                    this.productType = 'dishes';
                    break;
                case 'grocery-list':
                    this.serviceType = 'grocers';
                    this.productType = 'goods';
                    break;
                case 'pharmacy-list':
                    this.serviceType = 'pharmacies';
                    this.productType = 'drugs';
                    break;
                case 'assistant-list':
                    this.serviceType = 'assistants';
                    this.productType = 'options';
                    break;
                default:
                    this.serviceType = 'entities';
                    this.productType = 'entity_products';
                    break;
                }
            },
            removeProduct(id) {
                const _productsList = [];
                for(var i = 0; i < this.productsList.length; i++) {
                    if(id != this.productsList[i].id) {
                        _productsList.push(this.productsList[i]);
                    }
                }
                this.productsList = _productsList;
            },
            async updateProduct(item) {
                this.selectItem = item;
            },
            async updateProductDetail(item) {
                this.selectItem = item;
                this.model.product_id = item.id;
            },
            async clearProduct() {
                this.selectItem = null;
                this.model.product_id = null;
                this.model.service_type = null;
                this.model.entity_code_for_product = null;
                this.productDetailServiceType = '';
                this.productDetailProductType = '';
            },
            async loadProductDetail() {
                // Используем сохраненный service_type если есть, иначе определяем
                if (this.model.service_type) {
                    // Преобразуем service_type из единственного числа во множественное для API
                    this.productDetailServiceType = this.serviceTypeToPlural(this.model.service_type);
                    
                    // Устанавливаем productType
                    if (this.productDetailServiceType === 'restaurants') {
                        this.productDetailProductType = 'dishes';
                    } else if (this.productDetailServiceType === 'grocers') {
                        this.productDetailProductType = 'goods';
                    } else if (this.productDetailServiceType === 'pharmacies') {
                        this.productDetailProductType = 'drugs';
                    } else if (this.productDetailServiceType === 'entities') {
                        this.productDetailProductType = 'entity_products';
                    }
                } else if (this.model.entity_id_for_product) {
                    // Определяем тип сервиса для product_detail
                    const entityId = this.model.entity_id_for_product;
                    
                    // Проверяем в restaurants
                    if (this.business.restaurants.find(r => r.id === entityId)) {
                        this.productDetailServiceType = 'restaurants';
                        this.productDetailProductType = 'dishes';
                    }
                    // Проверяем в grocers
                    else if (this.business.grocers.find(g => g.id === entityId)) {
                        this.productDetailServiceType = 'grocers';
                        this.productDetailProductType = 'goods';
                    }
                    // Проверяем в pharmacies
                    else if (this.business.pharmacies.find(p => p.id === entityId)) {
                        this.productDetailServiceType = 'pharmacies';
                        this.productDetailProductType = 'drugs';
                    }
                    // Проверяем в entities
                    else {
                        this.productDetailServiceType = 'entities';
                        this.productDetailProductType = 'entity_products';
                        
                        // Находим entity_type_code
                        const entityTypes = Object.keys(this.business).filter(key => 
                            !['restaurants', 'grocers', 'pharmacies', 'assistants'].includes(key)
                        );
                        for (const typeKey of entityTypes) {
                            if (this.business[typeKey] && this.business[typeKey].find(e => e.id === entityId)) {
                                this.productDetailEntityTypeCode = typeKey;
                                break;
                            }
                        }
                    }
                    
                    // Сохраняем определенный service_type в модель (в единственном числе)
                    this.model.service_type = this.serviceTypeToSingular(this.productDetailServiceType);
                }
                
                try {
                    const items = await Vue.axios.get(`/${this.productDetailServiceType}/products/items`, { 
                        params: { ids: JSON.stringify([this.model.product_id]) } 
                    });
                    if (items.data && items.data.length > 0) {
                        this.selectItem = items.data[0];
                    }
                } catch (err) {
                    console.log('Cannot load product detail.');
                }
            },
            cancelModal() {
                this.visible = false;
                this.selectItem = null;
            },
            async getProductsByIds(serviceType, entitiesIds) {
                const items = await Vue.axios.get(`/${serviceType}/products/items`, { params: { ids: JSON.stringify(entitiesIds) } });
                for (const ids of entitiesIds) {
                    for (const item of items.data) {
                        if (ids === item.id) {
                            this.productsList.push(item)
                        }
                    }
                }
            },
            getTitleService(serviceId) {
                let services = [];
                let service;
                switch (this.model.route_name) {
                    case 'restaurant-list':
                        services = this.business.restaurants;

                        break;
                    case 'grocery-list':
                        services = this.business.grocers;
                        break;
                    case 'pharmacy-list':
                        services = this.business.pharmacies;
                        break;
                    case 'assistant-list':
                        services = this.business.assistants;
                        break;
                    default:
                        break;
                    }
                if (services.length) {
                    for (const serv of services) {
                        if (serv.id === serviceId) {
                            service = serv;
                        }
                    }
                    return service ? `${service.title}` : '';
                }
            }
        },
    };
</script>
<style lang="scss">
    .banner-item-edit {
        &__product_title {
            display: flex;
            align-items: center;
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
        }
        .autocomplete-input {
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            border: 1px solid #d8dbe0;
            border-radius: 0.25rem;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-color: #fff;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 0.875rem;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5;
        }
        .autocomplete-result {
            cursor: default;
            padding: 0.375rem 0.75rem 0.375rem 2rem;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2NjIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
            background-size: 15px;
            background-position: left 0.75rem center;
            background-repeat: no-repeat;
            color: #768192;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.1;
        }
    }
        .cbadge {
        cursor: pointer;
    }
</style>
